<template>
  <div class="form-group row">
    <label :for='name' class="col-md-4 col-form-label text-md-right">
      {{ display || name }}
    </label>
    <div class="col-md-6">
      <select
          v-if='type === "select"'
          :class="['form-control', { 'is-invalid': !!error }]"
          :id='name'
          :name='name'
          :value='value'
          @input="$emit('input', $event.target.value)"
          :multiple="multiple">
        <option v-for='o in (options || [])' :key='o.value' :value='o.value'>{{o.display}}</option>
      </select>
      <b-form-textarea
          v-else-if="type === 'textarea'"
          :class="['form-control', { 'is-invalid': !!error }]"
          style="white-space: pre-wrap"
          :id="name"
          :name="name"
          :value="value"
          @input="$emit('input', $event)"/>
      <input
          v-else-if="type === 'checkbox'"
          :class="['form-control', { 'is-invalid': !!error }]"
          :type='type'
          :id='name'
          :name='name'
          :checked='value === true'
          @input="$emit('input', $event.target.value)"/>
      <input
          v-else
          :class="['form-control', { 'is-invalid': !!error }]"
          :type='type'
          :id='name'
          :name='name'
          :value='value'
          @input="$emit('input', $event.target.value)"/>

      <span v-if='error' class="invalid-feedback" role="alert">
        <strong>{{ error.join(',') }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'type', 'display', 'value', 'options', 'error', 'multiple'],
}
</script>
